import styled from "styled-components";
export * from "./competitionFilterHeader";

export const CompetitionTournamentWrapper = styled.div<{
  isApp: number | null;
}>`
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1;
  height: 100vh;
  padding-top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};
  padding-bottom: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};

  > .banner-swiper {
    padding-top: 48px;
    position: relative;
    > .page-wrapper {
      z-index: 2;
      position: absolute;
      bottom: 12px;
      right: 16px;
      padding: 3px 8px;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.2);
      color: var(--Black-200, #b7b7b7);

      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: -0.24px;
      > span {
        color: #fff;
      }
    }
  }
`;

export const Header = styled.div<{
  isApp: number | null;
}>`
  position: fixed;
  max-width: 500px;
  z-index: 1000;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  width: 100%;
  min-height: 48px;
  color: #fff;

  font-size: 16px;
  font-weight: 600;
  gap: 10px;
  background: white;
  padding-top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};
  padding-bottom: ${(p) => (p.isApp ? "20px" : "0px")};

  .close {
    cursor: pointer;
    width: 24px;
    height: 24px;

    svg path {
      stroke: var(--Black-400, #444);
    }
  }

  .title {
    transition: all 0.1s ease-in-out;
    color: var(--Black-400, #444);

    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const CompetitionTournamentMainBanner = styled.img`
  width: 100%;
  aspect-ratio: 144 / 30;
  object-fit: cover;
`;

export const CompetitionTournamentSelector = styled.div`
  padding: 9px 8px 9px 12px;
  border-radius: 15px;
  border: 1px solid var(--Black-200, #b7b7b7);
  gap: 2px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  > .value {
    color: var(--Black-500, #202020);

    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > img {
    width: 14px;
    height: 14px;
  }
`;

export const CompetitionTournamentDropDownBox = styled.div`
  z-index: 2;
  position: absolute;
  top: 40px;
  left: -10px;
  max-height: 350px;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
  > .item {
    text-align: center;
    width: 68px;
    padding: 8px 0px;
    border-radius: 15px;
    border: 1px solid var(--Black-100, #f0f0f0);
    color: var(--Black-500, #202020);

    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > .item.active {
    color: white;
    border: none;
    background: var(--Purple-300, #6436e7);
  }
`;

export const CompetitionHorizontalBar = styled.div`
  width: 100%;
  padding-top: 3px;
  color: var(--Black-100, #f0f0f0);
  background: var(--Black-100, #f0f0f0);
  display: block;
`;

export const CompetitionBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px 16px;
  gap: 12px;

  > .header {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    > .description {
      color: #828282;

      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 25.771px; /* 214.762% */

      > span {
        font-weight: 700;
      }
    }
  }

  > .list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;
